import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import i18n from 'i18n-js';

import { scale } from '@components/frame';

import { BlockTypes } from '@v2/context/Times/page/interfaces';

import Header from './Header';
import Inputs from './Inputs';

import { font } from '@styles/fonts';
import { ColorFunction } from '@styles/colors/types';

const StatisticLine = ({ C, borderBottom, name, value }: { C: ColorFunction; borderBottom?: boolean; name: string; value: string }) => {
  return (
    <View
      style={[
        {
          width: '100%',
          justifyContent: 'space-between',
          flexDirection: 'row',
          height: scale(38),
          borderTopColor: C('Hairline/Light/No trans'),
          borderTopWidth: StyleSheet.hairlineWidth,
          alignItems: 'center',
        },
        borderBottom && {
          borderBottomColor: C('Hairline/Light/No trans'),
          borderBottomWidth: StyleSheet.hairlineWidth,
        },
      ]}
    >
      <Text style={[font['Subhead 1'], { color: C('Label/Light/Tertiary') }]}>{i18n.t(name)}</Text>
      <Text style={[font.Body, { color: C('Label/Light/Tertiary'), fontVariant: ['tabular-nums'] }]}>{value}</Text>
    </View>
  );
};
const Statistics = ({ header, C, fastest, average }: { header: string; C: ColorFunction; fastest: string; average: string }) => {
  return (
    <View style={{ paddingHorizontal: scale(15) }}>
      <Text style={[font.Headline, { color: C('Label/Light/Tertiary'), marginBottom: scale(7) }]}>{header}</Text>
      <StatisticLine {...{ C, name: 'Fastest', value: fastest }} />
      <StatisticLine {...{ C, name: 'Average', borderBottom: true, value: average }} />
    </View>
  );
};

export default ({
  C,
  name,
  status,
  statusColor,
  ideal,
  scheduled,
  manualIdeal,
  manualScheduled,
  idealAutomatic,
  scheduledAutomatic,
  fastest,
  average,
  amount,
  amountName,
  loading,
}: BlockTypes) => {
  const idealContext = 'ideal';
  const scheduledContext = 'scheduled';

  return (
    <View style={{ width: '100%' }}>
      <Header {...{ C, name, status, statusColor }} />
      <View style={{ marginTop: scale(8) }}>
        <Inputs
          {...{
            loading,
            context: idealContext,
            storage: ideal,
            manual: manualIdeal,
            automatic: idealAutomatic,
            C,
            underlineText: i18n.t(`Automatic: the ${idealContext} time is determined by the median (50th percentile), meaning half of the recorded times are above and half below.`),
          }}
        />
      </View>
      <View style={{ marginTop: scale(34) }}>
        <Inputs
          {...{
            loading,
            context: 'scheduled',
            storage: scheduled,
            manual: manualScheduled,
            automatic: scheduledAutomatic,
            C,
            underlineText: i18n.t(`Automatic: the ${scheduledContext} time is determined by the average of recorded times.`),
          }}
        />
      </View>
      <View style={{ marginTop: scale(27) }}>
        <Statistics {...{ header: i18n.t(`Statistics based on {{amount}} ${amountName}`, { amount: amount ?? 0 }), C, fastest, average }} />
      </View>
    </View>
  );
};
